import classes from "./MainContainer.module.css";
import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Routers from "../components/routes/Routes";
import NewSidebar from "./common/NewSidebar";
import { useSelector } from "react-redux";

const MainContainer = ({ title, handleToggleSidebar }) => {
  const { PROTECTED_ROUTES } = Routers();
  const location = useLocation();

  const [activeParentRoute, setActiveParentRoute] = useState({});

  useEffect(() => {
    if (location.pathname === "/api-document") {
      window.open(`https://documenter.getpostman.com/view/19785617/2sB2xCi9ZX`);
    }
  }, [location.pathname === "/api-document"]);

  let processedRoutes = PROTECTED_ROUTES.flatMap((route) => {
    return [
      route.childRoutes
        ? route.childRoutes.map((childRoute, id) => {
            return (
              <Route
                key={id}
                path={`${route.url + childRoute.url}`}
                element={childRoute.component}
              />
            );
          })
        : [],
      <Route path={route.url} element={route.component} />,
    ];
  })
    .filter(Boolean)
    .flat();

  const isSidebarOpen = useSelector((state) => state.sidebar.isSidebarOpen);

  return (
    <div>
      {/* <div className={classes.Title}>{title}</div> */}
      {/* <div className="right-panel">
        <Header handleToggleSidebar={handleToggleSidebar} />
      </div> */}
      <div className="flex flex-1 overflow-hidden pt-[69px]">
        {
          <NewSidebar
            activeRoute={activeParentRoute}
            setActiveRoute={setActiveParentRoute}
            handleToggleSidebar={handleToggleSidebar}
          />
        }
        {/* <div
          className={`${classes.Child} ${isSidebarOpen ? "" : "!pl-[12px]"}`}
        > */}
        <div
          className={`transition-all duration-300 ease-in-out flex-1 ${
            classes.Child
          } ${isSidebarOpen ? "w-[84vw]" : "!w-[95vw]"}`}
        >
          <Routes>{processedRoutes}</Routes>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default MainContainer;
